import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import PropTypes from 'prop-types'

import { useGlobalState } from '@/state'
import useQuery from '@/hooks/useQuery'
import Loading from '@/shared/Loading'
import StatusPill from '@/shared/StatusPill'
import Section from '@/pages/Users/PublicProfile/Section'

const Row = ({ userCredit }) => (
  <li className='flex items-start gap-x-3'>
    <img className='h-10 w-10 flex-shrink-0 rounded-lg bg-gray-200 object-cover' src={userCredit.imageUrl} alt='' />
    <div className='min-w-0 flex-1'>
      <div className='flex flex-wrap items-center gap-x-2 text-xs uppercase text-gray-500 dark:text-gray-400'>
        {userCredit.year}{ userCredit.stage && <StatusPill status='default' text={userCredit.stage} /> }
      </div>
      <Link to={`/credits/${userCredit.slug}`} className='block truncate text-sm font-semibold text-cccblue'>{userCredit.name}</Link>
      <div className='text-sm text-gray-600 dark:text-gray-300'>{userCredit.creditType}{ userCredit.role && <> as {userCredit.role}</> }</div>
      { userCredit.parentName && <div className='text-xs text-gray-500 dark:text-gray-400'>Part of <Link to={`/credits/${userCredit.parentSlug}`}>{userCredit.parentName}</Link></div> }
    </div>
  </li>
)

// First five ride in with the profile; "Show all" fetches the rest.
const PublicCredits = () => {
  const [profileContainer] = useGlobalState('profileContainer')
  const { getRequest } = useQuery()
  const { user, userCredits = [], userCreditsCount = 0 } = profileContainer
  const [all, setAll] = useState(null)
  const [loading, setLoading] = useState(false)

  const list = all || userCredits
  if (userCreditsCount === 0) { return null }

  const fetchAll = () => {
    setLoading(true)
    getRequest(`/api/v3/users/${user.id}/user_credits`, { page: 1 }, (err, jsonData) => {
      setLoading(false)
      if (err) { return }
      setAll(jsonData.userCredits || [])
    })
  }

  return <Section title='Credits' aside={ !all && userCreditsCount > list.length && <button type='button' onClick={fetchAll} className='text-xs font-semibold text-cccblue hover:underline'>Show all {userCreditsCount}</button> }>
    <ul className='space-y-3'>{ list.map((uc) => <Row key={`uc${uc.id}`} userCredit={uc} />) }</ul>
    { loading && <Loading /> }
  </Section>
}

export default PublicCredits

Row.propTypes = { userCredit: PropTypes.object.isRequired }
